import Crud from '../components/Question/Crud';
import Add from '../components/Question/Add';
import View from '../components/Question/View';

let routes = {
    path: '/question',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/question',
            component: Crud
        },
        {
            path: '/question/add',
            component: Add
        },
        {
            path: '/question/view/:id',
            component: View
        },
    ]
};

export default routes;


// WEBPACK FOOTER //
// ./src/router/question.js